import styled from 'styled-components'

export const Divider = styled.hr`
	border: none;
	border-top: 1px solid #e9ecef;
	margin: 1.25rem 0;
`

export const SectionLabel = styled.div`
	font-size: 0.7rem;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: #9ca3af;
	margin-bottom: 0.875rem;
`

export const LoadingText = styled.p`
	font-size: 0.85rem;
	color: #6c757d;
	margin: 0;
`

export const ShareRow = styled.div<{ $disabled?: boolean }>`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 1.5rem;
	opacity: ${props => (props.$disabled ? 0.5 : 1)};
	transition: opacity 0.2s ease;
`

export const ShareText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`

export const ShareTitle = styled.span`
	font-size: 0.95rem;
	font-weight: 600;
	color: #212529;
`

export const ShareDescription = styled.span`
	font-size: 0.8rem;
	color: #6c757d;
	line-height: 1.5;
`

export const MasterStatus = styled.span<{ $isPublic: boolean }>`
	font-size: 0.75rem;
	font-weight: 600;
	color: ${props => (props.$isPublic ? '#198754' : '#6c757d')};
	margin-top: 0.5rem;
	display: block;
`

/** Vertical stack of the six per-section toggles. */
export const SectionList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.1rem;
	margin-top: 1.25rem;
`

export const WarningNote = styled.p`
	margin: 0.5rem 0 0;
	padding: 0.5rem 0.75rem;
	font-size: 0.78rem;
	line-height: 1.45;
	color: #92400e;
	background: #fffbeb;
	border: 1px solid #fde68a;
	border-radius: 8px;
`

export const CopyLinkArea = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	margin-top: 1.5rem;
`

export const CopyLinkButton = styled.button`
	align-self: flex-start;
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.55rem 1rem;
	font-size: 0.85rem;
	font-weight: 600;
	color: #198754;
	background: #ffffff;
	border: 1px solid #198754;
	border-radius: 8px;
	cursor: pointer;
	transition: background 0.15s ease, opacity 0.15s ease;

	&:hover:not(:disabled) {
		background: #f0fdf4;
	}

	&:disabled {
		color: #adb5bd;
		border-color: #dee2e6;
		cursor: not-allowed;
	}
`

export const CopyLinkHint = styled.span`
	font-size: 0.75rem;
	color: #6c757d;
`

export const ToggleWrapper = styled.div`
	position: relative;
	flex-shrink: 0;
	margin-top: 2px;
`

export const ToggleInput = styled.input`
	opacity: 0;
	width: 0;
	height: 0;
	position: absolute;
`

export const ToggleSlider = styled.label<{ $checked: boolean; $disabled: boolean }>`
	display: block;
	width: 44px;
	height: 24px;
	background: ${props => (props.$checked ? '#198754' : '#dee2e6')};
	border-radius: 24px;
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	transition: background 0.2s ease;
	opacity: ${props => (props.$disabled ? 0.5 : 1)};
	position: relative;

	&::after {
		content: '';
		position: absolute;
		top: 3px;
		left: ${props => (props.$checked ? '23px' : '3px')};
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background: white;
		transition: left 0.2s ease;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
	}
`
